import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
  Button,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { RootState } from '../../../redux/rootState';
import { Cancel } from '../../../media/images/Cancel';
import DataTable from '../../../Common/DataTable';
import { Datatablestyle } from '../../ComponentNavBar/utils/Constant';
import { PreviousBidsTableData } from '../../ComponentNavBar/utils/TypeDashboard';
import { stripCustPrefix } from '../../../utils/CommonFunctions';
import ComponentTextInput from '../../../Common/ComponentTextinput/ComponentTextInput';
import { getPreviousBidsFailure, getPreviousBidsStart } from './redux/jobStarterSlice';

interface IPreviousBidsModal {
  open: boolean;
  handleClose: () => void;
}

export default function PreviousBidsModal({
  open, handleClose,
}: IPreviousBidsModal) {
  const dispatch = useDispatch();
  const [enabled, setEnabled] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [serVal, setSerVal] = useState('');
  const { control, watch, setValue } = useForm();

  const closeModal = () => {
    dispatch(getPreviousBidsFailure());
    setValue('serial', '');
    handleClose();
  };

  const serNum = watch('serial');

  const getData = () => {
    if (enabled) {
      if (serNum) {
        const payload = {
          SearchItem: serNum,
          pageSize: size,
          pageNumber: 1,
        };
        dispatch(getPreviousBidsStart(payload));
        setPage(1);
        setSerVal(serNum);
      }
    }
  };
  useEffect(() => {
    if (serVal) {
      const payload = {
        SearchItem: serVal,
        pageSize: size,
        pageNumber: page,
      };
      dispatch(getPreviousBidsStart(payload));
      setValue('serial', serVal);
    }
  }, [size, page]);

  const { previousBidsData } = useSelector((state: RootState) => state.jobsReducer);

  const receivedReports = useMemo(() => {
    if (previousBidsData) {
      setEnabled(false);
    }
    const received = previousBidsData?.Data?.map((item, index) => ({
      id: String(index + 1),
      jobDate: item?.BidCreationDate,
      jobId: item?.JobId,
      site: item?.SiteName,
      siteCity: item?.City,
      custId: stripCustPrefix(item?.CustomerId),
      custName: item?.CustomerName,
      serialToolTip: item?.SerialNumber,
      modelToolTip: item?.Model,
      totalBid: item?.TotalBid,
    }));
    return received;
  }, [previousBidsData]);

  const receivedColumns = [
    { key: 'jobDate', label: 'Date' },
    { key: 'jobId', label: 'Job #' },
    { key: 'site', label: 'Site' },
    { key: 'siteCity', label: 'Site City' },
    { key: 'custId', label: 'Cust #' },
    { key: 'custName', label: 'Customer' },
    { key: 'serialToolTip', label: 'Serial #' },
    { key: 'modelToolTip', label: 'Model' },
    { key: 'totalBid', label: 'Total Bid ($)' },
  ];

  // const downloadExcel = () => {
  //   if (forecastReportData?.length > 0) {
  //     const exportedData = forecastReportData?.map((items) => ({
  //       JobId: items?.JobId,
  //       BidId: items?.BidId,
  //       'Schedule Info': items?.UnitIds?.join(', '),
  //       CustomerId: stripCustPrefix(items?.CustId),
  //       Customer: items?.CustomerName,
  //       Site: items?.SiteName,
  //       'Site State': items?.SiteState,
  //       'Bid Amount ($)': Number(items?.BidAmount),
  //     }));
  //     exportToExcelData(
  //       {
  //         data: exportedData?.length > 0 ? exportedData : [],
  //         removeSn: true,
  //       },
  //       'FORECAST REPORT',
  //     );
  //   } else {
  //     showErrorToaster('No records to export');
  //   }
  // };

  const handleText = (_name: string, text: string) => {
    if (text?.length === 0) {
      setEnabled(false);
    } else {
      setEnabled(true);
    }
  };

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={Datatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Previous Bids based on Serial#
          </div>
          <div className="cancel-icon" onClick={() => closeModal()}>
            <Cancel />
          </div>

        </div>
        <div className="customModalBtnContainer">
          <div className="forecastButtonContainer">
            <div className="div_label_text">
              <label className="label_Style_serial">
                Serial #
              </label>
              <ComponentTextInput
                control={control}
                name="serial"
                id="serial"
                size="small"
                handleChange={handleText}
              />
            </div>
            <Button
              className={enabled ? 'button_save_and_next' : 'button_cancel cursorNotAllowed'}
              sx={{ height: 36, marginTop: '20px' }}
              onClick={getData}
            >
              Search Previous Bids
            </Button>
          </div>
          {/* <div className="pointCursor" onClick={downloadExcel}>
            <PrintIcon />
          </div> */}
        </div>
        <DataTable<PreviousBidsTableData>
          data={receivedReports || []}
          columns={receivedColumns}
          handleData={() => {}}
          totalRecords={previousBidsData?.TotalCount}
          page={page}
          rowsPerPage={size}
          setPage={setPage}
          setRowsPerPage={setSize}
        />
      </Box>
    </Modal>
  );
}
